var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Battery"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3671 3.72195H15.8821V1.49445C15.8821 1.08445 15.5496 0.751953 15.1396 0.751953H10.6871C10.2771 0.751953 9.94461 1.08445 9.94461 1.49445V3.72195H8.45961C7.64211 3.72195 6.97461 4.38945 6.97461 5.20695V23.0195C6.97461 23.852 7.62711 24.5045 8.45961 24.5045H17.3646C18.1971 24.5045 18.8496 23.852 18.8496 23.0195V5.20445C18.8496 4.37195 18.1971 3.71945 17.3646 3.71945L17.3671 3.72195ZM12.9146 20.0495V15.597H9.94461L12.9146 8.17445V12.627H15.8846L12.9146 20.0495Z",
    fill: "#0C71C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/Battery.a592f4fc2560609dfc5ba1a0a01318ec.svg";
export { ForwardRef as ReactComponent };